var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17209 24.0002C0.940287 24.0002 0.713675 23.9315 0.520921 23.8027C0.328167 23.674 0.177931 23.4909 0.0892164 23.2768C0.000501992 23.0626 -0.0227054 22.8269 0.0225297 22.5996C0.0677649 22.3722 0.17941 22.1634 0.343344 21.9995L21.9996 0.34328C22.2194 0.123481 22.5175 0 22.8283 0C23.1392 0 23.4373 0.123481 23.6571 0.34328C23.8769 0.563078 24.0004 0.861188 24.0004 1.17203C24.0004 1.48287 23.8769 1.78098 23.6571 2.00078L2.00084 23.657C1.89211 23.766 1.76292 23.8524 1.6207 23.9113C1.47848 23.9702 1.32602 24.0004 1.17209 24.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8283 24.0002C22.6743 24.0004 22.5219 23.9702 22.3797 23.9113C22.2374 23.8524 22.1083 23.766 21.9995 23.657L0.34328 2.00078C0.123481 1.78098 0 1.48287 0 1.17203C0 0.861188 0.123481 0.563078 0.34328 0.34328C0.563078 0.123481 0.861188 0 1.17203 0C1.48287 0 1.78098 0.123481 2.00078 0.34328L23.657 21.9995C23.821 22.1634 23.9326 22.3722 23.9778 22.5996C24.0231 22.8269 23.9999 23.0626 23.9112 23.2768C23.8224 23.4909 23.6722 23.674 23.4795 23.8027C23.2867 23.9315 23.0601 24.0002 22.8283 24.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.63c7a57a6ae29e25db869df4c73c9637.svg";
export { ForwardRef as ReactComponent };